/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define(['require',
		'jquery',
		'knockout'],
function (require, $, ko) {
	var device = {};
	// device or environment libraries
	device.dvDev = (function (require, $, ko) {
		//function dvDev() {
		var dvDev = {};

		//NOTE: always return lower-case strings...WR
		dvDev.platform = function () { return 'win32'; };
		dvDev.version = function () { return '1.0' };
		dvDev.model = function () { return ''; };
		dvDev.uuid = function () { return ''; };

		//web version, opens a new window/tab in the browser that is running the project...BC
		//the window/tab setting is controlled by the user in the options they set on their personal machines...BC
		function openBrowserWindow(url) { window.open(url); };

		//Return the device interface.
		return dvDev;
	})(require, $, ko);

	device.dvFS = (function (require, $, ko, dvDev) {
		if (window.requestFileSystem == null)
			window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;

		var dvFS = {};

		//Private methods and variables.
		var os = "win";

		//Public methods and properties.
		dvFS.dataDirectory = "data/";
		dvFS.applicationStorageDirectory = "storage/";
		dvFS.tempDirectory = "temp/";
		dvFS.sep = "/";


		//Return a handle to the specific path; will return fileEntry or dirEntry as 
		// appropriate to the path that was specified.
		dvFS.openFile = function (filePath, fileName, options, onSuccess, onError) {
			function gotDir(dirEntry) {
				//attempt to get the file.
				dirEntry.getFile(fileName, { create: false },
					function (fileEntry) {
						onSuccess(fileEntry);	//got file, return a handle to it.
						return;
					},
					onError	//error getting file.
				);
			}

			function onInitFs(fs) {
				//attempt to get the directory.
				fs.root.getDirectory(filePath, { create: false }, gotDir, onError);
			}

			try {
				//attempt to get the file system.
				window.requestFileSystem(window.PERSISTENT, 0, onInitFs, onError);
			} catch (e) {
				if (onError) onError(e);
			}
		}

		dvFS.closeFile = function (file, onSuccess, onError) {
			try {
				file = null;
				onSuccess();
			} catch (e) {
				if (onError) { onError(e); }
			}
		}

		//Destructively write a file. If the file exists, remove it and re-write it.
		//If the file does not exist, create it.
		dvFS.writeFile = function (filePath, fileName, contents, onSuccess, onError) {
			dvFS.removeFile(filePath, fileName,
				completeFile,
				function (err) {
					//If unable to remove because the file doesn't exist, write the file.
					if (fileErrorText(err) == 'NOT_FOUND_ERR') {
						completeFile();
						return;
					}
					//Other error, return it to the caller.
					if (onError) {
						onError(err);
						return;
					}
				}
			);

			//If the file was removed or doesn't exist, write the file.
			function completeFile() {
				dvFS.makeDirectory(filePath, function (dirEntry) {
					commitFile(dirEntry, fileName, contents);
				}, onError);
			}

			function commitFile(dirEntry, fileName, contents) {
				dirEntry.getFile(fileName, { create: true, exclusive: true },
					function (fileEntry) {
						fileEntry.createWriter(
							function (fileWriter) {
								fileWriter.write(contents);
								onSuccess(fileEntry);	//wrote the file, return handle to it.
								return;
							},
							onError	//error getting file writer.
						);
					},
					onError	//error getting file entry.
				);
			}
		}

		dvFS.removeFile = function (filePath, fileName, onSuccess, onError) {

			function initFS(fs) {
				fs.root.getDirectory(dvFS.dataDirectory, { create: false },
					function (dirEntry) {
						dirEntry.getDirectory(filePath, { create: false },
							function (dirEntry) {
								dirEntry.getFile(fileName, { create: false, exclusive: true },
									function (fileEntry) { fileEntry.remove(onSuccess, onError); },
									intError
								);
							},
							intError
						);
					},
					intError);
			}

			function intError(err) {
				if (err.code == FileError.NOT_FOUND_ERR) {
					//If not found, then the remove is still a success...
					onSuccess();
					return;
				}
				if (onError) onError(err);
			}

			try {
				window.requestFileSystem(window.PERSISTENT, 0, initFS, onError);
			} catch (e) {
				if (onError) onError(e);
			}
		}

		dvFS.makeDirectory = function (dirPath, onSuccess, onError) {

			function createDir(rootDirEntry, folders, onSuccess, onError) {
				// Throw out './' or '/' and move on to prevent something like '/foo/.//bar'.
				if (folders[0] == '.' || folders[0] == '') { folders = folders.slice(1); }
				rootDirEntry.getDirectory(folders[0], { create: true },
					function (dirEntry) {
						// Recursively add the new subfolder (if we still have another to create).
						if (folders.length) {
							createDir(dirEntry, folders.slice(1),
								function () {
									onSuccess(dirEntry);
									return;
								}, onError);
						}
					},
					onError	//error getting directory entry.
				);
			};

			function onInitFs(fs) {
				createDir(fs.root, dirPath.split(dvFS.sep), onSuccess, onError);
			}

			try {
				window.requestFileSystem(window.PERSISTENT, 0, onInitFs, onError);
			} catch (e) {
				if (onError) onError(e);
			}

		}

		dvFS.removeDirectory = function (path, onSuccess, onError) {
			function initFS(fs) {
				fs.root.getDirectory(path, { create: false },
					function (dirEntry) {
						if (dirEntry == null) {
							// directory is already gone...
							onSuccess();
							return;
						}
						dirEntry.removeRecursively(onSuccess, onError);
					},
					function (err) {
						if (err.code == FileError.NOT_FOUND_ERR) {
							//If not found, then the remove is still a success...
							onSuccess();
							return;
						}
						if (onError) { onError(err); }
					}
				);
			}

			try {
				window.requestFileSystem(window.PERSISTENT, 0, initFS, onError);
			} catch (e) {
				if (onError) onError(e);
			}

		}

		dvFS.fileErrorText = function (e) {
			switch (e.code) {
				case FileError.QUOTA_EXCEEDED_ERR:
					return 'QUOTA_EXCEEDED_ERR';
					break;
				case FileError.NOT_FOUND_ERR:
					return 'NOT_FOUND_ERR';
					break;
				case FileError.SECURITY_ERR:
					return 'SECURITY_ERR';
					break;
				case FileError.INVALID_MODIFICATION_ERR:
					return 'INVALID_MODIFICATION_ERR';
					break;
				case FileError.INVALID_STATE_ERR:
					return 'INVALID_STATE_ERR';
					break;
				default:
					return 'Unknown Error';
					break;
			};

		}

		//Return the file system interface.
		return dvFS;
	})(require, $, ko, device.dvDev);

	device.dvGeo = (function (require, $, ko) {
		var dvGeo = {};


		return dvGeo;
	})(require, $, ko);

	device.dvNet = (function (require, $, ko) {
		var dvNet = {};


		return dvNet;
	})(require, $, ko);

	device.dvNotify = (function (require, $, ko) {
		var dvNet = {};



		return dvNet;

	})(require, $, ko);

	device.dvCap = (function (require, $, ko, dvDev) {
		var dvCap = {};
		dvCap.os = "";

		if (dvDev.platform() === 'win32') {
			dvCap.os = "win"
		} else if (dvDev.platform() === '') {
			dvCap.os = "osx"
		}

		//Private methods and variables.


		//Public methods and properties.



		//Return the media capture interface.
		return dvCap;
	})(require, $, ko, device.dvDev);

	return device;
});
